<div class="page" [ngClass]="{ 'p-0': removeDashboardPadding }">
  <sb-sidebar [menuItems]="menuItems" [title]="'My' | translate" (onLocked)="handleOnLock($event)"> </sb-sidebar>
  <div class="w-full min-w-1">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</div>
